import React, { useState } from 'react';
import './CTASection.css';
import LeadPopup from './LeadPopup';

function CTASection() {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    return (
        <section className="cta-final-section">
            <div className="cta-final-container animate-fadeInUp">
                <div className="cta-final-content">
                    <h2 className="cta-final-title">Ready to Transform Your <span className="gradient-text-premium">Banking Future?</span></h2>
                    <p className="cta-final-subtitle">Join the next generation of financial institutions scaling with IGNOSI's intelligent SaaS ecosystem.</p>
                    <div className="cta-final-buttons">
                        <button className="btn-get-started-final" onClick={() => setIsPopupOpen(true)}>Get Started Now</button>
                        {/* <button className="btn-contact-sales-final">Contact Sales</button> */}
                    </div>
                </div>
                <div className="cta-final-decorative">
                    <div className="decorative-circle pulse"></div>
                    <div className="decorative-circle glow"></div>
                </div>
            </div>
            <LeadPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
        </section>
    );
}

export default CTASection;
